import { MaterialInfo, TracedMaterial } from '../traced-material'
import { BatchTracingSpec } from '../../spec/batch-tracing-spec'
import { BatchTracingConf } from '../../conf/batch-tracing-conf'

export class GroupedTracedMaterials {
  constructor(
    public specId: string,
    public tracedMaterials: TracedMaterial[],
    public distinctMaterialInfo: MaterialInfo[],
    public spec: BatchTracingSpec,
    public conf: BatchTracingConf
  ) {}
}
